import { Amplify } from "aws-amplify";

Amplify.configure({
  Auth: {
    Cognito: {
      username: "true",
      region: process.env.REACT_APP_AWS_REGION,
      userPoolId: process.env.REACT_APP_USER_POOL_ID,
      identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID,
    },
  },
  // Storage: {
  //   region: config.s3.REACT_APP_REGION,
  //   bucket: config.s3.BUCKET,
  //   identityPoolId: config.cognito.REACT_APP_IDENTITY_POOL_ID,
  // },
  API: {
    REST: {
      api: {
        endpoint: process.env.REACT_APP_MRE_API_BASE_URL,
        region: process.env.REACT_APP_AWS_REGION,
      },
    },
  },
});
